<app-page-meta pageTitle="finzy - Auto Invest"></app-page-meta>
<app-header></app-header>
<div class="wrapper container-fluid" *ngIf="!isFullScreenLoaderShown">
    <div *ngIf="gaugedInvestments && gaugedInvestments.length > 0">
        <app-auto-invest-header [gaugedInvestments]="gaugedInvestments"></app-auto-invest-header>
        <app-auto-partial-invest [investmentAmount]="portfolioCreationData.portfolioAmount"
                                 [remainingAmount]="remainingAmount"
                                 *ngIf="remainingAmount !== 0">
        </app-auto-partial-invest>

        <app-portfolio-preferences-picker #preferencesComponent class="col-xs-12 col-md-8 col-md-offset-2"
                                          style="margin-bottom: 1em"
                                          [preferredCategories]="portfolioCreationData.portfolioPreference"
                                          (onPreferredCategoriesChanged)="onPreferredCategoriesChanged($event)">
            <div heading>You can customise finzyPRO+ for this portfolio</div>
            <div collapsedPreDescription>We have picked these loans based on your rating preference:</div>
            <div collapsedPostDescription>If you wish to customise what loans are picked in this portfolio, you can
                change the preferences by <a [routerLink]="" (click)="preferencesComponent.expand()"><b>clicking
                    here</b></a>.
            </div>
            <div expandedPreDescription>Increasing the rating categories may help finzyPRO+ find you more loans.</div>
            <div expandedPostDescription>Click on FIND LOANS to have finzyPRO+ algorithm find you loans based on your
                rating preference.</div>
            <div positiveButtonText>FIND LOANS</div>
        </app-portfolio-preferences-picker>

        <app-auto-invest-loans [gaugedInvestments]="gaugedInvestments"
                               [investmentAmount]="portfolioCreationData.portfolioAmount"
                               (onInvestmentConfirmed)="createPortfolio(gaugedInvestments)"
                               (onInvestmentCancelled)="onInvestmentCancelled()"></app-auto-invest-loans>
    </div>
    <app-auto-invest-no-loans [portfolioCreationData]="portfolioCreationData"
                              (onInvestmentConfirmed)="createPortfolio(gaugedInvestments)"
                              (onPreferredCategoriesChanged)="onPreferredCategoriesChanged($event)"
                              *ngIf="gaugedInvestments && gaugedInvestments.length === 0">
    </app-auto-invest-no-loans>
</div>
<app-footer></app-footer>
